export const staticKeywordsDefault = ['Marketing', 'HR', 'Projektový manažment', 'Financie', 'Inovácie', 'Analýza']

export const additionalFlexiKeywords = ['pracujucemamy']
